export const GET_SHIP_STAGES = "GET_SHIP_STAGES";
export const GET_SHIP_STAGE_BY_ID = "GET_SHIP_STAGE_BY_ID";
export const UPDATE_SHIP_STAGE = "UPDATE_SHIP_STAGE";
export const DELETE_SHIP_STAGE = "DELETE_SHIP_STAGE";
export const CREATE_SHIP_STAGE = "CREATE_SHIP_STAGE";
